var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "group-content" },
    [
      _c("text-area-row", {
        attrs: {
          title: "SummaryReport.Operation.Description",
          id: "opreationdescription_" + _vm.index,
          required: true,
          maxLength: 50,
          rows: 1
        },
        model: {
          value: _vm.operation.description,
          callback: function($$v) {
            _vm.$set(_vm.operation, "description", $$v)
          },
          expression: "operation.description"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-row", {
        attrs: {
          title: "SummaryReport.Operation.OperationCount",
          id: "operationcount_" + _vm.index,
          rules: {
            min_value: 0,
            max_value: _vm.operation.encounterCount
              ? _vm.operation.encounterCount
              : 1000000000
          },
          required: true
        },
        model: {
          value: _vm.operation.operationCount,
          callback: function($$v) {
            _vm.$set(_vm.operation, "operationCount", $$v)
          },
          expression: "operation.operationCount"
        }
      }),
      _vm._v(" "),
      _c("single-select-accessible", {
        attrs: {
          title: "SummaryReport.Operation.OperationType",
          options: _vm.optionsArray("UpdatedOperationTypeOptions", true),
          required: true,
          fixedDirection: true,
          dropdownId: "operationtype_" + _vm.index
        },
        model: {
          value: _vm.operation.updatedOperationType,
          callback: function($$v) {
            _vm.$set(_vm.operation, "updatedOperationType", $$v)
          },
          expression: "operation.updatedOperationType"
        }
      }),
      _vm._v(" "),
      _c("radio-button-row", {
        attrs: {
          title: "SummaryReport.Operation.DirectContact",
          componentIndex: _vm.index,
          required: true
        },
        model: {
          value: _vm.operation.directContact,
          callback: function($$v) {
            _vm.$set(_vm.operation, "directContact", $$v)
          },
          expression: "operation.directContact"
        }
      }),
      _vm._v(" "),
      _vm.operation.directContact
        ? _c("numeric-input-row", {
            attrs: {
              title: "SummaryReport.Operation.EncounterCount",
              id: "encountercount_" + _vm.index,
              rules: {
                min_value: _vm.operation.operationCount
                  ? _vm.operation.operationCount
                  : 0,
                max_value: 1000000000
              },
              required: true
            },
            model: {
              value: _vm.operation.encounterCount,
              callback: function($$v) {
                _vm.$set(_vm.operation, "encounterCount", $$v)
              },
              expression: "operation.encounterCount"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.operation.directContact
        ? _c("radio-button-option-row", {
            attrs: {
              title: "SummaryReport.Operation.CollectionMethod",
              required: true,
              componentIndex: _vm.index,
              options: _vm.optionsArray("UpdatedCollectionMethodOptions", true)
            },
            model: {
              value: _vm.operation.updatedCollectionMethod,
              callback: function($$v) {
                _vm.$set(_vm.operation, "updatedCollectionMethod", $$v)
              },
              expression: "operation.updatedCollectionMethod"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }